var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/cookies-alert-privacy.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<p class=\"c-cookies-alert__p\">\n    ";
output += runtime.suppressValue((lineno = 1, colno = 5, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["cookies_alert_disclaimer"])), env.opts.autoescape);
output += "&nbsp;&nbsp;<a href=\"";
output += runtime.suppressValue((lineno = 1, colno = 62, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "helpUrl"), "helpUrl", context, [(lineno = 1, colno = 64, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["cookies-policy-help-url"]))])), env.opts.autoescape);
output += "\" class=\" c-cookies-alert__a\">";
output += runtime.suppressValue((lineno = 1, colno = 124, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["cookies_alert_find_out_more"])), env.opts.autoescape);
output += "</a>\n</p>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/cookies-alert-privacy.j2"] , dependencies)